import { GUI } from "three/examples/jsm/libs/dat.gui.module.js";

const _instance = new GUI()
export default _instance